const sharedRoutes = {
  contactSupport: '/contact-support',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  settings: '/settings',
  creatorApply: '/creator/apply',
};

export default sharedRoutes;
